import { render, staticRenderFns } from "./ReestrFSTEK.vue?vue&type=template&id=eb2ce33a&scoped=true&"
import script from "./ReestrFSTEK.vue?vue&type=script&lang=js&"
export * from "./ReestrFSTEK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2ce33a",
  null
  
)

export default component.exports